import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import PoolsList from './PoolsList';
import PoolLobby from './PoolLobby';
import DraftRoom from './DraftRoom';
import CreatePoolModal from './CreatePoolModal';
import QueuesManager from './QueuesManager';
import './pools.css';

export default function PoolsView({ userId, onBalanceChange, lang = 'en' }) {
  const [selectedPoolId, setSelectedPoolId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showQueues, setShowQueues] = useState(false);

  useEffect(() => {
    if (!selectedPoolId) { setSelectedStatus(null); return; }
    let active = true;
    const load = async () => {
      const { data } = await supabase.from('pools').select('status').eq('id', selectedPoolId).single();
      if (active && data) setSelectedStatus(data.status);
    };
    load();
    const channel = supabase
      .channel(`poolsview-${selectedPoolId}`)
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'pools', filter: `id=eq.${selectedPoolId}` }, (payload) => {
        // use the status from the event if present, otherwise re-read it
        if (active && payload?.new?.status) setSelectedStatus(payload.new.status);
        else load();
      })
      .subscribe();
    return () => { active = false; supabase.removeChannel(channel); };
  }, [selectedPoolId]);

  const handleCreated = (data) => {
    setShowCreate(false);
    if (data?.new_balance !== undefined) onBalanceChange?.(data.new_balance);
    if (data?.pool_id) setSelectedPoolId(data.pool_id);
  };

  if (showQueues) {
    return (
      <QueuesManager
        userId={userId}
        onBack={() => setShowQueues(false)}
        lang={lang}
      />
    );
  }

  if (selectedPoolId && selectedStatus === 'drafting') {
    return (
      <DraftRoom
        poolId={selectedPoolId}
        userId={userId}
        onBack={() => setSelectedPoolId(null)}
        lang={lang}
      />
    );
  }

  if (selectedPoolId) {
    return (
      <PoolLobby
        poolId={selectedPoolId}
        userId={userId}
        onBack={() => setSelectedPoolId(null)}
        onBalanceChange={onBalanceChange}
        onStatusChange={setSelectedStatus}
        lang={lang}
      />
    );
  }

  return (
    <>
      <PoolsList
        userId={userId}
        onSelect={setSelectedPoolId}
        onCreate={() => setShowCreate(true)}
        onOpenQueues={() => setShowQueues(true)}
        lang={lang}
      />
      {showCreate && (
        <CreatePoolModal
          userId={userId}
          onClose={() => setShowCreate(false)}
          onCreated={handleCreated}
          lang={lang}
        />
      )}
    </>
  );
}
